angular.module('FlexyBeautyApp').factory('CookieFactory', ["ipCookie", function (ipCookie) {

    return {
        getCookie: function (name) {
            return ipCookie(name);
        },

        getAllCookies: function () {
            return ipCookie();
        },

        setCookie: function (name, value) {
            return ipCookie(name, value, {expires: 100});
        },

        removeCookie: function (name) {
            return ipCookie(name, null);
        },
        setCookieRoot: function (name, value) {
            return ipCookie(name, value, {expires: 100, path: '/'});
        },

        removeCookieRoot: function (name) {
            return ipCookie(name, null, {path: '/'});
        }
    }
}]);



// WEBPACK FOOTER //
// ./js/services/tools/Cookie.js